module.exports={
  "Description": "LC : CCNN NNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^LC[0-9]{5}$",
  "TestData": {
    "Valid": [
      "LC12 345",
      "LC12345"
    ],
    "Invalid": [
      "12345",
      "x1231s",
      "1231sd"
    ]
  }
}